import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceEmployeesApi } from "@/services/employees/index";

const LayoutPageEmployee = lazy(() => import("./layout/index"));

export const loaderDataEmployee = async (args: any) => {
  try {
    const { employeeId } = args.params;

    if (!employeeId) {
      throw new Error("EMPLOEE_ID_REQUIRED");
    }

    const employee = serviceEmployeesApi.fetchEmployeeById(employeeId);

    if (!employee) {
      throw new Error("EMPLOEE_NOT_FOUND");
    }

    return employee;
  } catch (err) {
    console.error(err);
    throw new Error("EMPLOEE_NOT_FOUND");
  }
};

export const routerPageEmployee: RouterItemType = {
  path: "/employees/:employeeId",
  authorize: true,
  element: <LayoutPageEmployee />,
  loader: loaderDataEmployee,
};
